import { axios } from "@/lib/axios";
import {ClassItem} from "@/features/Classes/types";

export const copyClass = (id: number, enableQuizV2Api: boolean = false): Promise<ClassItem> => {
    const endpoint = enableQuizV2Api ? `/api/v2/admin/class/${id}` : `/api/admin/class/${id}`;
    return axios.post(endpoint);
}
